import { Component } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { PwaInstallService } from '../pwa-install.service';

/**
 * Bannière d'installation (Android / desktop installable) — fidèle à la maquette :
 * logo albR, libellé, bouton « Installer », fermeture. Affichée uniquement sur
 * mobile (sur desktop on garde l'icône d'installation native du navigateur) et
 * jamais si l'utilisateur a déjà refusé/installé.
 */
@Component({
  selector: 'pwa-install-banner',
  templateUrl: './pwa-install-banner.component.html',
  styleUrls: ['./pwa-install-banner.component.scss'],
  standalone: false,
})
export class PwaInstallBannerComponent {
  private readonly closed$ = new BehaviorSubject<boolean>(false);

  /** Émet `true` quand la bannière doit être visible. */
  readonly show$: Observable<boolean>;

  constructor(private readonly install: PwaInstallService) {
    this.show$ = combineLatest([this.install.installable$, this.closed$]).pipe(
      map(
        ([installable, closed]) =>
          installable &&
          this.install.isMobile &&
          !this.install.installInviteDismissed &&
          !closed,
      ),
    );
  }

  onInstall(): void {
    this.closed$.next(true);
    void this.install.promptInstall();
  }

  dismiss(): void {
    this.closed$.next(true);
    this.install.dismissInstall();
  }
}
